module.exports = __webpack_public_path__ + "videos/about-768@2x.cbcd9ed.mp4";